import { AxiosResponse } from 'axios'
import BaseAPI from '../../api'
import { FindAllInterface } from '../../apiModel'

const path = 'payment-type'

export interface PaymentTypeInterface {
    paymentServiceId?: number
    paymentName: string
    paymentNameEn?: string
    status: string
  }

export default class PaymentTypeApi extends BaseAPI {
    static findAll(props: FindAllInterface): Promise<any> {
        return this.api.get(path, { params: { ...props } }).then((res) => res)
    }

    static create(paymentName: string, paymentNameEn: string) {
        return this.api.post(path , { paymentName, paymentNameEn })
    }

    static findById(id: number): Promise<PaymentTypeInterface> {
        return this.api.get(`${path}/${id}`)
    }

    static update(id: number, body: PaymentTypeInterface) {
        return this.api.patch(`${path}/${id}`, body)
    }

    static updateStatus(id: number, status: string): Promise<any> {
        return this.api.patch(`${path}/${id}/status`, { id, status })
    }

    static delete(id: number) {
        return this.api.delete(`${path}/${id}`)
    }

}
